import { render } from "./iconCurvaInscripcionMovil.vue?vue&type=template&id=41eb4f07&scoped=true"
import script from "./iconCurvaInscripcionMovil.vue?vue&type=script&lang=js"
export * from "./iconCurvaInscripcionMovil.vue?vue&type=script&lang=js"

import "./iconCurvaInscripcionMovil.vue?vue&type=style&index=0&id=41eb4f07&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41eb4f07"

export default script